import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';

type TProps = {
  tab: string;
  setTab: (v: string) => void;
};

export const Tabs = ({ tab, setTab }: TProps) => {
  return (
    <HeaderSwitchWrapper key="tabSwitcher">
      <SwitchButton active={tab === 'words'} onClick={() => setTab('words')}>
        By Words
      </SwitchButton>
      <SwitchButton active={tab === 'lines'} onClick={() => setTab('lines')}>
        By Lines
      </SwitchButton>
    </HeaderSwitchWrapper>
  );
};
